import { memo } from 'react';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { ScopeSet } from 'root/src/shared/@types/auth';
import { Provider } from 'root/src/shared/@types/providers';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignModalShell } from 'root/src/client/v2/common/components/RedesignModalShell';
import { RedesignUpgradePermissionsModal } from 'root/src/client/v2/auth/redesign/RedesignUpgradePermissionsModal';
import { useCreateGiveawayModal } from 'root/src/client/v2/giveaways/features/CreateGiveawayModal/hooks/useCreateGiveawayModal';
import { RedesignCreateGiveawayForm } from 'root/src/client/v2/giveaways/features/CreateGiveawayModal/components/RedesignCreateGiveawayForm';
import { Skeleton } from 'root/src/client/v2/common/components/ui/skeleton';
// Redesign of CreateGiveawayModal: renders in the redesign modal shell/context and routes the
// chat-permission step + close through the redesign modal context (additive injects on the shared
// useCreateGiveawayModal hook). Uses the fresh RedesignCreateGiveawayForm and the giveaway logic.
export const RedesignCreateGiveawayModal = memo((props) => {
    const redesignModal = useRedesignModal();
    const requestChatPermission = () => new Promise((resolve) => {
        redesignModal.show(<RedesignUpgradePermissionsModal header="Announce in your chat" autoLabel="Automatically announce the giveaway in my chat (recommended)" manualLabel="I will announce the giveaway myself" autoDescription="We will post the giveaway link in your Twitch chat so your viewers can enter." manualDescription="You announce the giveaway in your chat yourself." scopeSet={ScopeSet.creatorPlus} provider={Provider.Twitch} onContinue={() => { redesignModal.hide(); resolve(true); }} onSuccess={() => { redesignModal.hide(); resolve(true); }} onCancel={() => { redesignModal.hide(); resolve(false); }}/>, { replace: false, closeable: false });
    });
    const { isLoading, giveaway, scheduler, giveawayConfig, onCancelScheduler, onSubmit, } = useCreateGiveawayModal({
        onSuccess: props.onSuccess,
        hideModal: redesignModal.hide,
        requestChatPermission,
    });
    return (<RedesignModalShell className="sm:max-w-lg">
			<div className="flex w-full flex-col items-center gap-3 text-center">
				<div className="flex h-12 w-12 items-center justify-center rounded-full border border-solid border-neon-amber/30 bg-neon-amber/10">
					<EmojiEventsIcon sx={{ fontSize: 24 }} className="text-neon-amber"/>
				</div>
				<h2 className="font-display text-xl font-bold text-foreground">Effortless giveaways</h2>
				<p className="text-sm text-muted-foreground">Set a schedule, then focus on your content.</p>
			</div>

			{isLoading ? (<div className="flex w-full flex-col gap-5" aria-busy="true">
					<div>
						<Skeleton className="mb-2 h-3 w-16"/>
						<Skeleton className="h-11 w-full rounded-xl"/>
					</div>
					<Skeleton className="h-11 w-full rounded-xl"/>
					<Skeleton className="h-24 w-full rounded-xl"/>
					<Skeleton className="h-10 w-full rounded-lg"/>
				</div>) : (<RedesignCreateGiveawayForm onSubmit={onSubmit} onCancel={onCancelScheduler} giveawayConfig={giveawayConfig} giveaway={giveaway} scheduler={scheduler}/>)}
		</RedesignModalShell>);
});
